import DefaultSlide from "../../components/Slides/templates/DefaultSlide";
import ImageSlide from "../../components/Slides/templates/ImageSlide";
import { ISlideObject } from "../../components/Slides/templates/ISlideObject";
import TitleSlide from "../../components/Slides/templates/TitleSlide";

export default function S01P02({ reveal }: ISlideObject) {
  return (
    <>
      <TitleSlide
        title="TI8512 - Desarrollo Ágil de Aplicaciones Web"
        subtitle="Semana 01 Parte 2"
      />
      <DefaultSlide title="Agenda">
        <div>
          <ul>
            <li>La evolución de la Web</li>
            <li>Comprendiendo la caja de herramientas</li>
            <li>Lenguajes de programación web.</li>
          </ul>
        </div>
      </DefaultSlide>
      <section>
        <TitleSlide title="Evolución de la web"></TitleSlide>
        <ImageSlide image="/images/S01/evolucion.jpg" />
        <DefaultSlide title="Tim Berners-Lee">
          <div className="col-no-padding dp-center">
            <img
              src="/images/S01/tim.jpg"
              width={300}
              alt="foto de Tim Berners-Lee."
            />
          </div>
          <div className="col" style={{ fontSize: "0.5em" }}>
            <ul>
              <li>Padre de la WEB.</li>
              <li>Creador de HTML.</li>
              <li>Estableció la primera conexión HTTP en 1989.</li>
              <li>Fundador de la W3C.</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="La evolución de la web">
          <div className="col">
            <img src="/images/S01/web.png" alt="evolución de la web" />
          </div>
          <div className="col">
            <ul>
              <li>Web 1.0: La web estática.</li>
              <li>Web 2.0: La web social.</li>
              <li>Web 3.0: La web semántica.</li>
            </ul>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Ejercicio">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p style={{ margin: "0" }}>
              Tomaremos 5 minutos para hacer una búsqueda en internet y añadir
              notas sobre las diferencias que marcaron la evolución de la web,
              desde 1.0 hasta 3.0.
            </p>
            <p>
              Anote sus hallazgos en su cuaderno de notas personal de one note.
            </p>
            <p className="fragment">Mario Brenes</p>
            <p className="fragment">Jose Torres</p>
          </div>
        </DefaultSlide>
        <ImageSlide image="/images/S01/everywhere.gif" />
      </section>
      <section>
        <TitleSlide title="Caja de herramientas (básica) 🛠️" />
        <section>
          <p>
            En el mundo del software y principalmente en el mundo web, debemos
            convertirnos en personas expertas que saben complementar las
            funcionalidades existentes y aprovechar al máximo las herramientas
            disponibles en el mercado (no hay que reinventar la rueda).
          </p>
          <p className="fragment">
            Es por esto que debemos aprender a utilizar todos los artefactos de
            nuestra caja de herramientas de forma correcta
          </p>
        </section>
        <DefaultSlide title="Lenguajes de programación web">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p>
              Es importante diferenciar los lenguajes de programación web de
              aquellos lenguajes que habilitan el uso de tecnología web mediante
              frameworks. Por ejemplo, Python es un lenguaje de programación
              multiparadigma que mediante el uso de Flask habilita el despliegue
              de aplicaciones web. Vamos entonces a hablar de lenguajes web como
              aquellos lenguajes que son de uso exclusivo del ecosistema web
            </p>
            <div className="col">
              <img
                width={200}
                src="/images/S01/javascript.png"
                alt="Javascript logo"
              />
              <img width={200} src="/images/S01/css.png" alt="Css logo" />
            </div>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Framework web">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p>
              En el contexto de programación web, un framework es un conjunto de
              herramientas, funcionalidades y utilizades de desarrollo en un
              lenguaje de programación que habilita el uso de tecnología web.
              Ejemplos de esto son Flask en Python, Gin en GoLang y Spring en
              Java.
            </p>
            <div className="col">
              <img
                width={300}
                src="/images/S01/flask.jpg"
                alt="flask python logo"
              />
            </div>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Interfaces gráficas">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p style={{ margin: "0" }}>
              Es la funcionalidad en una aplicación web que es visible para los
              usuarios finales.
            </p>
            <div className="col">
              <img width={400} src="/images/S01/ui.jpg" alt="usability meme" />
              <img
                className="fragment"
                width={300}
                style={{ marginLeft: "20px" }}
                src="/images/S01/usability.jpg"
                alt="usability meme"
              />
            </div>
          </div>
        </DefaultSlide>

        <DefaultSlide title="Framework web para front-end">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p style={{ margin: "0" }}>
              cuando hablamos de web front-end, se trata específicamente del uso
              de lenguajes web para generar interfaces gráficas. El uso de
              frameworks web ahorra mucho del trabajo inicial y permiten
              estandarizar comportamientos en los sitios web.
            </p>
            <div className="col">
              <img width={250} src="/images/S01/react.png" alt="react logo" />
              <img width={250} src="/images/S01/vue.webp" alt="vue logo" />
              <img
                width={250}
                style={{ marginLeft: "20px" }}
                src="/images/S01/angular.png"
                alt="angular logo"
              />
            </div>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Framework web para back-end">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p style={{ margin: "0" }}>
              Cuando hablamos de web back-end, nos referimos a la lógica de
              negocio y a la persistencia de datos. En este contexto, existen
              frameworks que permiten estandarizar el uso de tecnologías como
              bases de datos, autenticación y autorización, entre otras.
            </p>
            <div className="col">
              <img width={250} src="/images/S01/spring.jpg" alt="spring logo" />
              <img
                width={250}
                style={{ marginLeft: "20px" }}
                src="/images/S01/django.png"
                alt="django logo"
              />
              <img
                width={250}
                style={{ marginLeft: "20px" }}
                src="/images/S01/laravel.png"
                alt="laravel logo"
              />
            </div>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Framework web para aplicaciones móviles">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p style={{ margin: "0" }}>
              En el contexto de aplicaciones móviles, existen frameworks que
              permiten crear aplicaciones híbridas, es decir, aplicaciones que
              funcionan tanto en Android como en iOS. Estos frameworks permiten
              crear aplicaciones móviles utilizando lenguajes web.
            </p>
            <div className="col">
              <img
                width={250}
                src="/images/S01/reactnative.png"
                alt="react native logo"
              />
              <img width={250} src="/images/S01/ionic.png" alt="ionic logo" />
            </div>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Navegadores web">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p style={{ margin: "0" }}>
              Los navegadores web son aplicaciones que permiten a los usuarios
              acceder a la web. Existen diferentes navegadores web, cada uno con
              sus propias características y funcionalidades.
            </p>
            <div className="col">
              <img width={150} height={150} src="/images/S01/chrome.webp" alt="chrome logo" />
              <img
                width={150} height={150}
                src="/images/S01/firefox.png"
                style={{ marginLeft: "50px" }}
                alt="firefox logo"
              />
              <img width={250} height={150} src="/images/S01/safari.png" alt="safari logo" />
            </div>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Estándares web">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p style={{ margin: "0" }}>
              Los estándares web son un conjunto de especificaciones y
              recomendaciones que definen cómo deben funcionar las tecnologías
              web. Estos estándares son desarrollados por el World Wide Web
              Consortium (W3C) y son utilizados por los navegadores web para
              interpretar y mostrar el contenido web.
            </p>
            <div className="col">
              <img width={450} src="/images/S01/w3c.png" alt="w3c logo" />
            </div>
          </div>
        </DefaultSlide>
        <DefaultSlide title="Roadmap.sh">
          <div
            className="d-flex flex-column"
            style={{ width: "100%", fontSize: "0.7em" }}
          >
            <p style={{ margin: "0" }}>
              Roadmap.sh es una comunidad de desarrolladores que se dedican a
              crear y compartir hojas de ruta para aprender diferentes
              tecnologías y lenguajes de programación. Estas hojas de ruta son
              una guía visual que muestra los pasos a seguir para convertirte en
              un experto en una tecnología o lenguaje de programación.
            </p>
            <div className="col">
              <img
                width={250}
                src="/images/S01/roadmap.jpg"
                alt="roadmap logo"
              />
            </div>
          </div>
        </DefaultSlide>
      </section>
      <section>
        <TitleSlide title="Lenguajes de programación web." />
      </section>
      <ImageSlide image="/images/S01/party-dance.gif" title="¡Fin de la clase!">
        <p>
          Recuerda completar todos los contenidos de la semana.
        </p>
        {/* <button className="btn btn-success">Marcar como completo</button> */}
      </ImageSlide>
    </>
  );
}
